<template>
  <b-card class="boxCont">
    <b-row align-h="left" class="mbottom20 contBtnBack">
      <b-button class="btnBack" @click="onCancel">
        <i class="fa fa-angle-double-left"></i>
      </b-button>
      <h5 class="titleSession">
        <i class="fa fa-calendar"></i>
        <span class="shentox">{{ $t('messages.sessionDate') }}</span>
        <b class="shentox">{{ selectedItem.insertAt | moment("DD-MM-YYYY HH:mm:ss") }}</b>
      </h5>
    </b-row>
    <b-row>
      <div class="boxIcon">
        <b-card :no-body="true" class="cardBox">
          <b-card-body class="p-0 clearfix">
            <i class="text-muted fa fa-clock-o p-4 px-4 font-4xl mr-2 float-left"></i>
            <div v-if="selectedItem" class="h5 text-primary mb-0 pt-3 shentox">{{ getTotalTime(selectedItem.time) }}</div>
            <div class="text-muted text-uppercase font-weight-bold font-s shentox">{{ $t('messages.time') }}</div>
          </b-card-body>
        </b-card>
      </div>
      <div class="boxIcon">
        <b-card :no-body="true" class="cardBox">
          <b-card-body class="p-0 clearfix">
            <i class="text-muted fa fa-road p-4 px-4 font-4xl mr-2 float-left"></i>
            <div v-if="selectedItem" class="h5 text-primary mb-0 pt-3 shentox">{{ selectedItem.distance }} m</div>
            <div class="text-muted text-uppercase font-weight-bold font-s shentox">{{ $t('messages.totalDistance') }}</div>
          </b-card-body>
        </b-card>
      </div>
      <div class="boxIcon">
        <b-card :no-body="true" class="cardBox">
          <b-card-body class="p-0 clearfix">
            <i class="text-muted fa fa-tachometer p-4 px-4 font-4xl mr-2 float-left"></i>
            <div class="h5 text-primary mb-0 pt-3 shentox">{{ selectedItem.avgspeed  }} km/h</div>
            <div class="text-muted text-uppercase font-weight-bold font-s shentox">{{ $t('messages.speed') }}</div>
          </b-card-body>
        </b-card>
      </div>
      <div class="boxIcon">
        <b-card :no-body="true" class="cardBox">
          <b-card-body class="p-0 clearfix">
            <i class="text-muted fa fa-signal p-4 px-4 font-4xl mr-2 float-left"></i>
            <div class="h5 text-primary mb-0 pt-3 shentox">{{ parseFloat(selectedItem.energy / 10) }} Kcal</div>
            <div class="text-muted text-uppercase font-weight-bold font-s shentox">{{ $t('messages.energy') }}</div>
          </b-card-body>
        </b-card>
      </div>
      <div class="boxIcon">
        <b-card :no-body="true" class="cardBox">
          <b-card-body class="p-0 clearfix">
            <i class="text-muted fa fa-heartbeat p-4 px-4 font-4xl mr-2 float-left"></i>
            <div class="h5 text-primary mb-0 pt-3 shentox">{{ selectedItem.hrmax }} / <span class="small">{{ getAvgs('hr') }} bpm</span></div>
            <div class="text-muted text-uppercase font-weight-bold font-s shentox">HR Max / <span class="small">{{ $t('messages.avg') }}</span></div>
          </b-card-body>
        </b-card>
      </div>
      <div class="boxIcon">
        <b-card :no-body="true" class="cardBox">
          <b-card-body class="p-0 clearfix">
            <i class="text-muted fa fa-bolt p-4 px-4 font-4xl mr-2 float-left"></i>
            <div class="h5 text-primary mb-0 pt-3 shentox">{{ selectedItem.maxpower }} / <span class="small">{{ getAvgs('pow') }} watts</span></div>
            <div class="text-muted text-uppercase font-weight-bold font-s shentox">Max power / <span class="small">{{ $t('messages.avg') }}</span></div>
          </b-card-body>
        </b-card>
      </div>
    </b-row>
    <b-row>
      <b-col lg="12">
        <!-- <apexchart width="100%" type="line"  :options="options" :series="series"></apexchart> -->
        <session-data chartId="session-data" class="chart-wrapper" style="height:300px;" height="300" :session="selectedItem"></session-data>
      </b-col>
      <!-- <b-col lg="3">
        <c-table
          :table-data="selectedItem.laps"
          hover
          striped
          bordered
          small
          fixed
          :fields="fields"
          :caption="$t('messages.laps')"
        ></c-table>
      </b-col> -->
    </b-row>
    <b-row class="contNav">
      <b-btn @click="onPrevious" class="btnNav btnPrev">
        <i class="fa fa-angle-left"></i>
        <span>{{ $t('messages.previous') }}</span>
      </b-btn>
    
      <b-btn @click="onNext" class="btnNav btnNext">
        <span>{{ $t('messages.next') }}</span>
        <i class="fa fa-angle-right"></i>
      </b-btn>
    </b-row>
  </b-card>
</template>

<script>
import cTable from "../utils/Table.vue";
import SessionData from './SessionData.vue'

export default {
  name: "treadmillDashboard",
  components: {
    cTable,
    SessionData
  },
  props: {
    selectedItem: {
      type: Object,
      default: () => {}
    }
  },
  data: () => {
    return {
      currentPage: 1,
      fields: [
        {
          key: "n",
          label: "Num. "
        },
        {
          key: "t",
          label: "Time"
        }
      ],

    }
  },

  methods: {
    getTotalTime(duration) {
      var t = duration * 1000;
      var d = this.$moment.duration(t);
      var s = Math.floor(d.asHours()) + this.$moment.utc(t).format(":mm:ss");
      return s;
    },
    getAvgs(type){
      const current = this.selectedItem.data;
      if(current){
        let hr = 0;
        let pow = 0;
        this.selectedItem.data.forEach(element => {
          hr = hr + element.hr
          pow = pow + element.pow
        });
        if(type === 'hr'){
          return parseInt(hr / current.length) 
        }else{
          return parseInt(pow / current.length) 
        }
       
      }
    },
    onCancel() {
      this.$emit("on-cancel");
    },
    onPrevious() {
      this.$emit("on-prev");
    },
    onNext() {
      this.$emit("on-next");
    }
  }
};
</script>

<style scoped>
.boxIcon{
  display:block !important;
  float:left;
  position:relative;
  width:16.66%;
  padding:0 5px;
}
.boxIcon i{position:absolute;top:-10px;left:0;width:55px;text-align: center;}
.boxIcon div:nth-child(2),.boxIcon div:nth-child(3){padding-left:55px;}
@media screen and (max-width:1400px){
.boxIcon{width:33.33% !important;}

}
.mbottom20 {
  margin-bottom: 20px;
}

.ptop10 {
  padding: 8px 20px 0 20px;
  margin-bottom: 0 !important;
}

.btnBack {
  /* position: absolute;
    top: 0;
    left: 20px; */
  margin-left: 17px;
  background: none;
  border: 0;
  font-size: 20px;
  position: relative;
  padding-right: 20px;
  border-radius: 0;
}
.btnBack:after {
  content: "";
  width: 1px;
  height: 20px;
  position: absolute;
  top: 50%;
  right: 0;
  border-right: 1px solid #666;
  transform: translateY(-50%);
}
.btnNav {
  background: none;
  border: 0;
  font-size: 20px;
  position: relative;
}
/* .btnPrev:after{
    content:"";width:1px;height:20px;position:absolute;top:50%;right:0;border-right:1px solid #666;transform:translateY(-50%);
}
.btnNext:after{
    content:"";width:1px;height:20px;position:absolute;top:50%;left:0;border-right:1px solid #666;transform:translateY(-50%);
} */
.shentox {
  font-family: "Shentox";
}
.boxCont {
  position: relative;
  padding-bottom: 30px;
}
.titleSession {
  font-size: 15px;
  padding: 11px 0 0 20px !important;
}
.titleSession b {
  font-size: 1.1rem !important;
  font-weight: 700;
}
.titleSession i,
.titleSession span {
  color: #7cfef0;
}
.titleSession span {
  text-transform: uppercase;
  font-size: 0.9rem !important;
  font-weight: 700;
  margin: 0 10px 0 5px;
}
.contNav {
  margin: 0;
  width: 100%;
  display: block !important;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #333;
  padding: 0 30px;
}
.btnNav {
  display: inline-block !important;
  position: relative;
  border: 0 !important;
  outline: none !important;
  box-shadow: none !important;
}
.btnNav i {
  position: absolute;
  top: 15px;
}
.btnPrev {
  padding-left: 10px;
}
.btnPrev i {
  left: 0;
}
.btnNext i {
  right: 0;
}
.btnPrev span {
  margin-left: 10px;
}
.btnNext {
  float: right;
  padding-right: 10px;
}
.btnNext span {
  margin-right: 10px;
}
.btnNav span {
  font-size: 0.75rem !important;
  color: #999;
  text-transform: uppercase;
  line-height: 40px;
  display: inline-block !important;
}
.contBtnBack {
  position: relative;
}
.cardBox {
  padding-right:20px;
  background: #2f353a ;
  background-size: auto 120px;
  border: 0 !important;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  padding-bottom: 10px;
}
.cardBox *{z-index:2;}
.cardBox:before{width:40px;
height:50px;
background: url("/static/deco-titles4.svg")right bottom no-repeat;
background-size: 90px 50px;
position: absolute;bottom:-25px;right:-0px;
z-index:1;
content:"";
transform:rotate(45deg);
}
.pl-4, .px-4 {
    padding-left: 0.8rem !important;
    padding-right: 0.8rem !important;
}


/* .bg-tone1 {
  background: #03b5aa;
}

.bg-tone2 {
  background: #037971;
}

.bg-tone3 {
  background: #2cda9d;
}

.bg-tone4 {
  background: #03b5aa;
} */
</style>



// WEBPACK FOOTER //
// src/components/treadmill/Treadmill-dashboard.vue